import DapDSCodePuncherSlot from './code-puncher-slot.component'

export * from './code-puncher-slot.component'
export default DapDSCodePuncherSlot

DapDSCodePuncherSlot.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-code-puncher-slot': DapDSCodePuncherSlot
  }
}
